// Mock data for XION Medical Philippines Website
// This file contains all mock data that will be replaced with backend API calls

export const companyInfo = {
  name: "XION Medical",
  tagline: "See more than others.",
  subtitle: "Everything from one source – endoscopy systems since 1991.",
  description: "XION manufactures high-quality medical devices, endoscopes, and instruments for minimally invasive diagnostics and therapy. With interdisciplinary competence spanning over three decades, we deliver comprehensive endoscopy solutions that enable healthcare professionals to see more than others.",
  founded: 1991,
  logoUrl: "/assets/xion-logo.png",
  model3dUrl: "/assets/xion-logo.png"
};

export const distributor = {
  name: "Fortschritt Medical Supplies Incorporated (FMSInc.)",
  shortName: "FMSInc.",
  role: "Exclusive distributor in the Philippines",
  website: "https://www.fmsmedequip.com",
  displayUrl: "www.fmsmedequip.com",
  // Distributor exclusivity statement is client-provided; confirm legal wording.
  legalNote: "Exclusive distributor in the Philippines"
};

export const systemComponents = {
  officeClinic: {
    title: "Systems in the doctor's office and outpatient clinic",
    description: "Compact, efficient solutions designed for office-based procedures and outpatient care.",
    systems: [
      {
        id: "endooffice-spectar",
        name: "EndoOFFICE Spectar",
        description: "All-in-one workstation for office endoscopy with integrated HD visualization and documentation.",
        features: ["HD Visualization", "Integrated Documentation", "Compact Design", "Easy Operation"]
      },
      {
        id: "endocompact-veezar",
        name: "EndoCOMPACT Veezar",
        description: "Portable endoscopy solution with exceptional image quality for flexible clinical settings.",
        features: ["Portable Design", "4K Resolution", "Quick Setup", "Battery Backup"]
      }
    ]
  },
  hospital: {
    title: "Systems in the hospital",
    description: "Advanced systems for hospital environments demanding the highest performance and reliability.",
    systems: [
      {
        id: "endostrobe-spectar",
        name: "EndoSTROBE Spectar",
        description: "High-performance stroboscopic system for detailed laryngeal examination and voice diagnostics.",
        features: ["Stroboscopic Imaging", "Voice Analysis", "Recording Capability", "Professional Grade"]
      },
      {
        id: "endosurgery-spectar",
        name: "EndoSURGERY Spectar",
        description: "Surgical-grade endoscopy platform for operating room applications with maximum precision.",
        features: ["Surgical Precision", "OR Integration", "4K/60fps", "Sterile Workflow"]
      }
    ]
  }
};

export const useCases = [
  {
    id: "office",
    title: "Office Endoscopy",
    description: "Streamlined solutions for ENT practices and outpatient clinics.",
    icon: "Building2"
  },
  {
    id: "hospital",
    title: "Hospital Systems",
    description: "Advanced platforms for surgical and diagnostic departments.",
    icon: "Hospital"
  },
  {
    id: "diagnostics",
    title: "Diagnostics",
    description: "Precision instruments for comprehensive patient evaluation.",
    icon: "Activity"
  }
];

export const navLinks = [
  { name: "Products", href: "/products" },
  { name: "System Solutions", href: "/system-solutions" },
  { name: "Evidence", href: "/clinical-evidence" },
  { name: "Service & Support", href: "/service-support" },
  { name: "Company", href: "/company" },
  { name: "Events", href: "/events" },
  { name: "Contact (PH)", href: "/contact-ph" }
];

export const productCategories = [
  {
    id: "endoscopes",
    name: "Endoscopes",
    description: "Premium rigid and flexible endoscopes for various medical specialties.",
    items: ["Rigid Endoscopes", "Flexible Endoscopes", "Video Endoscopes"]
  },
  {
    id: "visualization",
    name: "Visualization Systems",
    description: "State-of-the-art camera systems and displays for optimal imaging.",
    items: ["Camera Heads", "Light Sources", "HD Monitors"]
  },
  {
    id: "documentation",
    name: "Documentation",
    description: "Comprehensive recording and archiving solutions.",
    items: ["Video Recorders", "Image Capture", "Archive Systems"]
  },
  {
    id: "instruments",
    name: "Instruments",
    description: "Specialized surgical and diagnostic instruments.",
    items: ["ENT Instruments", "Biopsy Tools", "Surgical Sets"]
  }
];

export const companyTimeline = [
  { year: 1991, event: "XION founded in Berlin, Germany" },
  { year: 1995, event: "First integrated endoscopy workstation launched" },
  { year: 2000, event: "Expansion into international markets" },
  { year: 2010, event: "HD technology integration across product line" },
  { year: 2015, event: "4K visualization systems introduced" },
  { year: 2020, event: "Partnership with FMSInc. for Philippine market" },
  { year: 2024, event: "Next-generation Spectar series launched" }
];

export const events = [
  {
    id: 1,
    title: "Philippine ENT Congress 2025",
    date: "March 15-17, 2025",
    location: "Manila, Philippines",
    description: "Visit our booth to experience the latest XION endoscopy systems."
  },
  {
    id: 2,
    title: "Medical Philippines Expo",
    date: "June 5-7, 2025",
    location: "SMX Convention Center, Pasay",
    description: "Live demonstrations of EndoOFFICE Spectar and EndoSURGERY Spectar."
  },
  {
    id: 3,
    title: "XION Product Training",
    date: "Quarterly",
    location: "FMSInc. Training Center",
    description: "Hands-on training sessions for healthcare professionals."
  }
];

export const services = [
  {
    id: "installation",
    title: "Installation & Setup",
    description: "Professional installation and configuration of XION systems."
  },
  {
    id: "training",
    title: "Training Programs",
    description: "Comprehensive training for medical staff and technicians."
  },
  {
    id: "maintenance",
    title: "Preventive Maintenance",
    description: "Regular maintenance to ensure optimal system performance."
  },
  {
    id: "repair",
    title: "Repair Services",
    description: "Fast, reliable repair services with genuine XION parts."
  },
  {
    id: "support",
    title: "Technical Support",
    description: "24/7 technical support hotline for urgent assistance."
  }
];
